function byteConverter(
    bytes = 0,
    omitUnits = false,
    decimals = 1,
    only = undefined,
) {
    const K_UNIT = 1024;
    const UNITS = ["B", "Kb", "Mb", "Gb", "Tb", "Pb"];

    if (bytes === 0) {
        return !omitUnits ? "0 B" : 0;
    }

    if (only === "Mb") {
        const result = (bytes / (K_UNIT * K_UNIT)).toFixed(decimals);

        return !omitUnits ? `${result} Mb` : parseFloat(result);
    }

    let i = Math.floor(Math.log(bytes) / Math.log(K_UNIT));
    const result = (bytes / Math.pow(K_UNIT, i)).toFixed(decimals);

    return !omitUnits ? `${parseFloat(result)} ${UNITS[i]}` : parseFloat(result);
}

export default byteConverter;
